import { render } from "./simple_ok.vue?vue&type=template&id=1e98088e"
import script from "./simple_ok.vue?vue&type=script&lang=js"
export * from "./simple_ok.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260519225122/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__